import 'ladda/dist/ladda-themeless.min.css';

import React from 'react';
import {RenderRoutes} from 'base/routes';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
import {Auth, User, System} from 'api';
import cookie from 'react-cookie';
import {Categories} from 'api';
import {getUserInfo} from 'base/actions';
import {loginWithFacebook} from 'base/actions/social-login/facebook';
import { ReduxAsyncConnect } from 'redux-connect';
import 'ladda';
import FacebookLogin from 'base/lib/social-login/Facebook';

class App extends React.Component {
  constructor(props, context) {
    super(props, context);

    if (typeof cookie.load('accessToken') == 'undefined') {
      // this.props.history.push('/');
    } else {
      this.props.dispatch(getUserInfo()).then(response => {
        return {
          isAuthenticated: true,
          data: response,
          isAdmin: response.isAdmin
        };
      });
    }

    this.props.dispatch(Categories.actions.list({}, null, {}));
    System.actions.detail.request({filter:{"where":{ "code": "fair_information"}}}).then(res => {
      if (res.data && res.data.length > 0) {
        let data = JSON.parse(res.data[0].data);
        this.props.dispatch({type: 'UPDATE_SYSTEM_INFO', data})
      }
    })
  }

  componentDidMount() {
    FacebookLogin.init();
  }

  render() {
    return (
      <div>
        {/* <ReduxAsyncConnect routes={this.props.route.routes} />*/}
        <RenderRoutes routes={this.props.route.routes}/>
      </div>
    );
  }
}

App.defaultProps = {
  defaultPage: "/categories"
};

App.contextTypes = {
  router: React.PropTypes.object
};

export default withRouter(connect()(App));



// WEBPACK FOOTER //
// ./components/app/index.js